"use client";

import { c as _c } from "react/compiler-runtime";
import type { Filter, FilterValue } from "@repo/design-system/types/filter";
import type { Option } from "@repo/design-system/types/filtermenu";
import { useCallback, useMemo } from "react";
import { useFilterSearchState } from "./use-filtersearch-state";
import { useGeosearchState } from "./use-geosearch-state";
import { useSearchqueryState } from "./use-searchquery-state";
export interface SearchSummaryOption extends Option {
  onRemove: () => Promise<void>;
}
export function useSearchSummary() {
  const $ = _c(26);
  const [search, setSearch] = useSearchqueryState();
  const [geo, setGeo] = useGeosearchState();
  const [filterState, setFilterState] = useFilterSearchState();
  let allOptions;
  if ($[0] !== filterState || $[1] !== geo.location || $[2] !== search || $[3] !== setFilterState || $[4] !== setGeo || $[5] !== setSearch) {
    allOptions = [];
    if (search) {
      const t0 = search as FilterValue;
      let t1;
      if ($[7] !== setSearch) {
        t1 = async () => {
          await setSearch(null);
        };
        $[7] = setSearch;
        $[8] = t1;
      } else {
        t1 = $[8];
      }
      let t2;
      if ($[9] !== search || $[10] !== t0 || $[11] !== t1) {
        t2 = {
          value: t0,
          label: search,
          count: 0,
          order: 0,
          onRemove: t1
        };
        $[9] = search;
        $[10] = t0;
        $[11] = t1;
        $[12] = t2;
      } else {
        t2 = $[12];
      }
      allOptions.push(t2);
    }
    if (geo.location) {
      const t0 = geo.location as FilterValue;
      let t1;
      if ($[13] !== setGeo) {
        t1 = async () => {
          await setGeo(null);
        };
        $[13] = setGeo;
        $[14] = t1;
      } else {
        t1 = $[14];
      }
      let t2;
      if ($[15] !== geo.location || $[16] !== t0 || $[17] !== t1) {
        t2 = {
          value: t0,
          label: geo.location,
          count: 0,
          order: 1,
          onRemove: t1
        };
        $[15] = geo.location;
        $[16] = t0;
        $[17] = t1;
        $[18] = t2;
      } else {
        t2 = $[18];
      }
      allOptions.push(t2);
    }
    for (const [filterType, filterValue] of Object.entries(filterState)) {
      if (filterValue) {
        const values = filterValue.split(",");
        for (const value of values) {
          allOptions.push({
            value: `${filterType as Filter}:${value}`,
            label: value.replace("_IN_", ","),
            count: 0,
            order: 1,
            onRemove: async () => {
              const currentValues = filterState[filterType]?.split(",") || [];
              const newValues = currentValues.filter(v => v !== value);
              await setFilterState({
                ...filterState,
                [filterType]: newValues.length > 0 ? newValues.join(",") : null
              });
            }
          });
        }
      }
    }
    $[0] = filterState;
    $[1] = geo.location;
    $[2] = search;
    $[3] = setFilterState;
    $[4] = setGeo;
    $[5] = setSearch;
    $[6] = allOptions;
  } else {
    allOptions = $[6];
  }
  const options = allOptions;
  let t0;
  if ($[19] !== setFilterState || $[20] !== setGeo || $[21] !== setSearch) {
    t0 = async () => {
      await setSearch(null);
      await setGeo(null);
      await setFilterState(null);
    };
    $[19] = setFilterState;
    $[20] = setGeo;
    $[21] = setSearch;
    $[22] = t0;
  } else {
    t0 = $[22];
  }
  const clearAllFilters = t0;
  let t1;
  if ($[23] !== clearAllFilters || $[24] !== options) {
    t1 = {
      options,
      clearAllFilters
    };
    $[23] = clearAllFilters;
    $[24] = options;
    $[25] = t1;
  } else {
    t1 = $[25];
  }
  return t1;
}